import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'


Vue.config.productionTip = false

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBoQ5cs55K1Ar46-cysRb5QrICUX7wE9Zc",
  authDomain: "covid-novel-2020.firebaseapp.com",
  databaseURL: "https://covid-novel-2020.firebaseio.com",
  projectId: "covid-novel-2020",
  storageBucket: "covid-novel-2020.appspot.com",
  messagingSenderId: "664107439432",
  appId: "1:664107439432:web:f19bf356d42a16da9f4f7d",
  measurementId: "G-2XNT9J9X9R"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
